import { StartSessionRequest } from '@nice-devone/common-sdk';
import { AdminService } from '@nice-devone/core-sdk';
import { logger } from '../../../utils/logger';
import type { VoicePreference } from '../types';

export async function buildStartSessionRequest(
  preference?: VoicePreference
): Promise<StartSessionRequest> {
  if (preference?.type === 'station' && preference.stationId) {
    logger.debug('[CXone SDK] Using station mode with stationId:', preference.stationId);
    return {
      stationId: preference.stationId,
      stationPhoneNumber: '',
    } as StartSessionRequest;
  }

  if (preference?.type === 'phone' && preference.phoneNumber) {
    logger.debug('[CXone SDK] Using phone mode with number:', preference.phoneNumber);
    return {
      stationId: '',
      stationPhoneNumber: preference.phoneNumber,
    } as StartSessionRequest;
  }

  logger.debug('[CXone SDK] Using Integrated Softphone mode...');

  try {
    const adminService = AdminService.instance;
    const agentSettings = await adminService.getAgentSettings();
    logger.debug('[CXone SDK] Agent settings for softphone:', agentSettings);

    if (agentSettings.webRTCDnis) {
      logger.debug(
        '[CXone SDK] Using WebRTC softphone mode (webRTCDnis:',
        agentSettings.webRTCDnis,
        ')'
      );
      return {
        stationId: '',
        stationPhoneNumber: 'WebRTC',
      } as StartSessionRequest;
    }

    logger.warn('[CXone SDK] No webRTCDnis found, trying empty values...');
  } catch (settingsError) {
    logger.warn('[CXone SDK] Failed to get agent settings, trying empty values:', settingsError);
  }

  return {
    stationId: '',
    stationPhoneNumber: '',
  } as StartSessionRequest;
}
